import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignHorizontalCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAlignHorizontalCenter"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM12.75 7H11.25V17H12.75V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlignHorizontalCenter;
